import { createListenerMiddleware } from "@reduxjs/toolkit";
import { authApi } from "../api/authApi";
import { brandApi } from "../api/brandApi";
import { chatApi } from "../api/chatApi";
import { dataConfidenceApi } from "../api/dataConfidenceApi";
import { mediaTypeApi } from "../api/mediaTypeApi";
import { productApi } from "../api/productApi";
import { retailerApi } from "../api/retailerApi";
import { scenarioApi } from "../api/scenarioApi";
import { settingsApi } from "../api/settingsApi";
import { subBrandApi } from "../api/subBrandApi";
import { adminSubBrandApi } from "../api/admin/adminSubBrandApi";
import { userApi } from "../api/userApi";
import type { AppDispatch, RootState } from "../app/store";
import { AppStorage } from "../features/storage/appStorage";
import { logout } from "../slices/userSlice";

export const authListenerMiddleware = createListenerMiddleware();

const startAppListening = authListenerMiddleware.startListening.withTypes<RootState, AppDispatch>();

startAppListening({
    matcher: authApi.endpoints.login.matchFulfilled,
    effect: async action => {
        if (!action.payload) {
            AppStorage.setAuthToken(null);
            AppStorage.setUserEmail(null);
            AppStorage.setUserRoles(null);
            AppStorage.setAuthTokenExpiry(null);
            return;
        }

        AppStorage.setAuthToken(action.payload.token);
        AppStorage.setAuthTokenExpiry(action.payload.expires_utc);
        AppStorage.setUserEmail(action.payload.info.email);
        AppStorage.setUserRoles(action.payload.info.roles);
    }
});

startAppListening({
    actionCreator: logout,
    effect: async (_, listenerApi) => {
        AppStorage.setAuthToken(null);
        AppStorage.setUserEmail(null);
        AppStorage.setUserRoles(null);
        AppStorage.setAuthTokenExpiry(null);

        listenerApi.dispatch(authApi.util.resetApiState());
        listenerApi.dispatch(brandApi.util.resetApiState());
        listenerApi.dispatch(chatApi.util.resetApiState());
        listenerApi.dispatch(mediaTypeApi.util.resetApiState());
        listenerApi.dispatch(productApi.util.resetApiState());
        listenerApi.dispatch(retailerApi.util.resetApiState());
        listenerApi.dispatch(scenarioApi.util.resetApiState());
        listenerApi.dispatch(settingsApi.util.resetApiState());
        listenerApi.dispatch(subBrandApi.util.resetApiState());
        listenerApi.dispatch(adminSubBrandApi.util.resetApiState());
        listenerApi.dispatch(userApi.util.resetApiState());
        listenerApi.dispatch(dataConfidenceApi.util.resetApiState());
    }
});
